import { render, staticRenderFns } from "./DriverUpload.vue?vue&type=template&id=470dcc2b&scoped=true"
import script from "./DriverUpload.vue?vue&type=script&lang=js"
export * from "./DriverUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470dcc2b",
  null
  
)

export default component.exports